import {
  FieldPath,
  FieldValues,
  RegisterOptions,
  UseFormReturn,
} from 'react-hook-form';

export const registerField = <T extends FieldValues>(
  form: Pick<
    UseFormReturn<T>,
    'formState' | 'setValue' | 'register' | 'getFieldState'
  >,
  name: FieldPath<T>,
  options: RegisterOptions<T> = {}
) => {
  const fieldState = form.getFieldState(name, form.formState);

  return {
    id: name,
    ...form.register(name, options),
    error: fieldState.error ? fieldState.error.message : undefined,
    touched: fieldState.isTouched,
  };
};

export const registerFieldWithoutRef = <T extends FieldValues>(
  form: UseFormReturn<T>,
  name: FieldPath<T>,
  options: RegisterOptions<T> = {}
) => {
  const {
    ref, // eslint-disable-line @typescript-eslint/no-unused-vars
    ...fieldState
  } = registerField(form, name, options);

  return fieldState;
};
